$(function() {
  const getPopup = document.querySelector('.home-popup-for-checkout__popup-status').textContent.trim();
  const getUser = document.querySelector('.home-popup-for-checkout__user-status').textContent.trim();
  const getCart = document.querySelector('.home-popup-for-checkout__cart-status').textContent.trim();
  const popupContent = document.querySelector('.home-popup-for-checkout');
  const popupButton = document.querySelector('.home-popup-for-checkout__button');
  const continueBrowsingButton = document.querySelector('.home-popup-for-checkout__button--link');
  const cookieElementStatus = document.querySelector('.home-popup-for-checkout__cookie-status');
  const checkCookie = async () => { // access cookies data
    try {
      let cookie = await cookieStore.get('home_popup_for_checkout');

      if (cookie) {
        console.log(`Found ${cookie.name} cookie: ${cookie.value}`);
      } else { // show popup when cookie is invalid/expired
        let body = $('body');

        body.addClass('mfp-no-scroll');

        $.magnificPopup.open({
          items: {
            src: popupContent,
            type: "inline",
          },
          fixedContentPos: true,
          callbacks: {
            close: function() {
              // prevent triggering createCookie() more than once
              if (cookieElementStatus.textContent != 'cookie-exists') {
                createCookie();
              }

              body.removeClass('mfp-no-scroll');
            }
          }
        });
        //if (cookies.expires === null) {}
      }
    } catch(e) {
      console.error(`Cookie store error: ${e}`);
    }
  }
  const createCookie = () => { // https://stackoverflow.com/questions/66005225/javascript-on-click-start-cookie-and-hide-element-for-24-hours
    let expires = '';
    let value = 'popup-disabled';
    let days = 1
    let date = new Date();

    // create cookie with 24 hours expiry
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "expires=" + date.toUTCString();
    document.cookie = 'home_popup_for_checkout' + '=' + value + ';' + expires + ';path=/';

    // show when it will expire
    console.log(expires);

    cookieElementStatus.textContent = 'cookie-exists';
    $.magnificPopup.close();

    // substitute for preventDefault();
    return false; 
  } 
  const redirectToCheckout = (event) => {
    event.preventDefault();

    window.location.href = '/checkout';
  }

  // popup will show when it is enabled, user is logged in and cart is not empty
  if (getPopup == 'true' && getUser == 'logged in' && getCart == 'not empty') {
    // access cookies data
    checkCookie();
  } else {
    // console.log('not logged in or cart is empty');
  }

  popupButton.addEventListener('click', redirectToCheckout);

  continueBrowsingButton.addEventListener('click', (e) => {
    e.preventDefault();

    createCookie();
  });
});